import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setRbacPrivileges,
  setRootSubscriptionPrivileges,
  setSubscriptionPrivileges,
} from "../Redux/privilegesSlice";

export default function useSetPrivilegesFromAuth() {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state?.authReducer);
  const FISubscriptionPrivileges = useSelector(
    (state) => state?.privilegesReducer?.FISubscriptionPrivileges?.data,
  );

  useEffect(() => {
    // Assume privileges string is at authReducer.userData.privileges
    if (authReducer?.userData?.privileges) {
      dispatch(setRbacPrivileges(authReducer.userData.privileges));
      dispatch(
        setRootSubscriptionPrivileges(authReducer.userData.product_Privileges),
      );
      if (FISubscriptionPrivileges != null) {
        dispatch(setSubscriptionPrivileges(FISubscriptionPrivileges));
        return;
      }
      dispatch(
        setSubscriptionPrivileges(authReducer.userData.product_Privileges),
      );
    }
  }, [
    authReducer?.userData?.privileges,
    authReducer?.userData?.product_Privileges,
    dispatch,
  ]);
}
